
const NS = 'PlanStructureService';

export default function PlanStructureService(SnapConst, SnapService) {
  "ngInject";

  function Structure() {}

  Structure.prototype = {

    applyResize: function (originalShape, anchor, move) {
      var rad = this.model.rotation * Math.PI / 180;
      var resizeOf;
      //Compute width and height resize based on structure rotation
      if (this.model.rotation % 90 === 0) {
        resizeOf = {
          w: move.x * Math.cos(rad) - move.x * Math.sin(rad),
          h: move.y * Math.sin(rad) + move.y * Math.cos(rad)
        };
        if (this.model.rotation === 90 || this.model.rotation === 270) {
          resizeOf = {
            w: resizeOf.h,
            h: resizeOf.w
          };
        }
      } else {
        resizeOf = {
          w: move.x * Math.cos(rad) + move.y * Math.sin(rad),
          h: move.y * Math.sin(rad) - move.x * Math.cos(rad)
        };
        if (this.model.rotation === 135 || this.model.rotation === 315) {
          resizeOf = {
            w: resizeOf.w,
            h: -resizeOf.h
          };
        }
      }
      //Apply resizable configuration to requested resize
      var nextSize = {
        w: originalShape.w + resizeOf.w,
        h: originalShape.h + resizeOf.h
      };
      if (this.resizable.wStep > 0) {
        nextSize.w = Math.ceil(nextSize.w / this.resizable.wStep) * this.resizable.wStep;
        if (this.resizable.wMax > 0 && nextSize.w > this.resizable.wMax) {
          nextSize.w = this.resizable.wMax;
        }
        if (this.resizable.wMin > 0 && nextSize.w < this.resizable.wMin) {
          nextSize.w = this.resizable.wMin;
        }
      } else {
        nextSize.w = originalShape.w;
      }
      if (this.resizable.hStep > 0) {
        nextSize.h = Math.ceil(nextSize.h / this.resizable.hStep) * this.resizable.hStep;
        if (this.resizable.hMax > 0 && nextSize.h > this.resizable.hMax) {
          nextSize.h = this.resizable.hMax;
        }
        if (this.resizable.hMin > 0 && nextSize.h < this.resizable.hMin) {
          nextSize.h = this.resizable.hMin;
        }
      } else {
        nextSize.h = originalShape.h;
      }
      //If needed apply the resize
      var resize = nextSize.w !== this.shape.w || nextSize.h !== this.shape.h;
      if (resize) {
        this.model.width = nextSize.w;
        this.model.height = nextSize.h;
        this.refresh(anchor);
      }
      return resize;
    },

    rotate: function (angle) {
      if (this.model.subType === Structure.SubTypes.TextOnly) {
        this.model.rotation = SnapService.rotate(this.getElement(), angle, this.shape.w / 2, this.shape.h / 2);
      } else {
        this.model.rotation = SnapService.rotate(this.getElement(), angle);
      }
      var crot = (angle > 0 ? -angle : Math.abs(angle));
      if (this.label) {
        SnapService.rotate(this.label, crot, 0, 0);
      }
      this.model.position = SnapService.place(this.getElement(), this.model.position.x, this.model.position.y);
    },

    place: function (position) {
      SnapService.place(this.getElement(), position.x, position.y);
      this.model.position = SnapService.getPosition(this.getElement());
    },

    beforeResize: function (anchor) {
      var info = {
        anchor: anchor
      };
      info.beforeSize = {
        w: this.element.shape.w,
        h: this.element.shape.h
      };
      info.afterSize = {
        w: this.model.width,
        h: this.model.height
      };
      if (this.model.rotation && (info.beforeSize.w !== info.afterSize.w || info.beforeSize.h !== info.afterSize.h)) {
        SnapService.rotate(this.element, -this.model.rotation);
      } else {
        info = null;
      }
      return info;
    },

    afterResize: function (info) {
      if (info) {
        SnapService.rotate(this.element, this.model.rotation);
        var afterCorners = SnapService.getRectCorners(info.afterSize, this.model.position, this.model.rotation);
        var delta = SnapService.diffPositions(info.anchor, afterCorners[0]);
        var afterPos = SnapService.sumPositions(this.model.position, delta);
        this.model.position = SnapService.place(this.element, afterPos.x, afterPos.y);
      }
    },

    getElement: function () {
      return this.element;
    }
  };
  /************************************************************************************************************************
   *************************************************************************************************************************
   STATIC ATTRIBUTES AND FUNCTIONS
   *************************************************************************************************************************
   ************************************************************************************************************************/

  Structure.Type = 'structure';
  Structure.SubTypes = {
    Wall: 'wall',
    Window: 'window',
    DoorLeft: 'doorLeft',
    DoorRight: 'doorRight',
    DoorDouble: 'doorDouble',
    FrameRect: 'frameRect',
    FrameCircle: 'frameCircle',
    TextOnly: 'textOnly'
  };

  Structure.Actions = {
    Spread: {
      name: 'spreader',
      icon: 'images/drag.svg',
      width: 10,
      height: 10
    }
  };

  Structure.getTypeName = function (subType) {
    switch (subType) {
      case Structure.SubTypes.Wall:
        return 'Wall';
      case Structure.SubTypes.Window:
        return 'Window';
      case Structure.SubTypes.DoorLeft:
        return 'Left Door';
      case Structure.SubTypes.DoorRight:
        return 'Right Door';
      case Structure.SubTypes.DoorDouble:
        return 'Double Door';
      case Structure.SubTypes.FrameRect:
        return 'Rectangle Text';
      case Structure.SubTypes.FrameCircle:
        return 'Circle Text';
      case Structure.SubTypes.TextOnly:
        return 'Text Only';
    }
  };

  Structure.hasLabel = function (subType) {
    var result = subType === Structure.SubTypes.FrameRect ||
      subType === Structure.SubTypes.FrameCircle ||
      subType === Structure.SubTypes.TextOnly;
    return result;
  };

  Structure.hasFillTheme = function (subType) {
    var result = subType === Structure.SubTypes.FrameRect ||
      subType === Structure.SubTypes.FrameCircle;
    return result;
  };

  Structure.rootBBox = function (model) {
    var size = {
      w: model.width,
      h: model.height
    };
    if (model.subType === Structure.SubTypes.TextOnly) {
      size.h = 15;
      size.w = 10 * (model.content ? model.content.length : 9 /*Text Only*/ );
    }
    return SnapService.getRectBox(size, model.position, model.rotation);
  };

  return Structure;
}
